 
import Translator from '@/components/translator.vue'

import Dictionary from '@/components/dictionary.vue'
 import Login from '@/components/login.vue'
 import Form from '@/components/form.vue'

import Giguser from '@/components/giguser.vue'
import Juniors from '@/components/juniors.vue'
import Manage from '@/components/manage.vue'

   export default[
 
  {
  	path:'/',component:Giguser,
    meta:{
      requiresAuth:true
    }
  } ,
    {
    path:'/juniors',component:Juniors,
    meta:{
      requiresAuth:true
    }
  } ,


  {
    path:'/form',component:Form,
     
  } ,



   {
    path:'/admin',component:Dictionary,
    meta:{
 
    }
  } ,
  {
    path:'/manage',component:Manage,
    meta:{
 
    }
  } ,
 
    { 
    
    path:'/login',component:Login,
    meta:{
 
    }
  } 
     


  ]





// WEBPACK FOOTER //
// ./src/router/index.js